import { BSkeletonWrapper } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBSkeletonWrapper = createEgBootstrapProxy(
  "EgBSkeletonWrapper",
  BSkeletonWrapper
);
